import styled from 'styled-components'

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const SegmentBar = styled.div`
  margin-bottom: 1.25rem;
`
